import React, { useEffect } from 'react';
import Footer from './common/home/Footer';
import TopBar from './common/home/TopBar';
import { styles } from './common/Styles';
import { Card, CardContent, CardHeader, Grid, Icon, Paper, Typography } from '@mui/material';
import { homeBackground, homeColor } from './common/ColorCodes';
import { HiLightBulb } from "react-icons/hi";
import { LiaCompressArrowsAltSolid } from "react-icons/lia";
import {
  FaHandshakeAngle,
  FaScaleUnbalanced,
  FaSunPlantWilt
} from "react-icons/fa6";
import { IoReloadCircleOutline } from "react-icons/io5";
import { CONST_SITE_LABEL } from './common/Helper';

export const About = () => {
  const ourValues = [
    {
      id: 'DTS001',
      active: 'true',
      icon: <HiLightBulb />,
      title: 'Innovation at the Core',
      description: 'Driving progress through creative thinking, we embrace innovation as the cornerstone of our solutions, constantly pushing boundaries to shape the future of cloud analytics.'
    },
    {
      id: 'DTS002',
      active: 'true',
      icon: <LiaCompressArrowsAltSolid />,
      title: 'Client-Centric Excellence',
      description: 'Our commitment to delivering unparalleled client satisfaction underscores every action, ensuring our solutions not only meet but exceed expectations.'
    },
    {
      id: 'DTS003',
      active: 'true',
      icon: <FaHandshakeAngle />,
      title: 'Collaboration for Impact',
      description: 'Fostering a culture of collaboration, we believe in the power of teamwork to achieve meaningful impact, working closely with clients and partners to drive success.'
    },
    {
      id: 'DTS004',
      active: 'true',
      icon: <FaScaleUnbalanced />,
      title: 'Integrity in Every Action',
      description: 'Guided by unwavering integrity, we conduct ourselves with honesty and transparency, building trust as the foundation of our relationships with clients and stakeholders.'
    },
    {
      id: 'DTS005',
      active: 'true',
      icon: <IoReloadCircleOutline />,
      title: 'Continuous Learning Culture',
      description: 'In a rapidly evolving tech landscape, we cultivate a culture of continuous learning, empowering our team to stay ahead and deliver cutting-edge solutions.'
    },
    {
      id: 'DTS006',
      active: 'true',
      icon: <FaSunPlantWilt />,
      title: 'Sustainability in Practice',
      description: 'Mindful of our environmental impact, we incorporate sustainable practices in our operations, striving for eco-friendly solutions and a positive contribution to the planet.'
    },
  ]
  useEffect(() => {
    document.title = `${CONST_SITE_LABEL} | About`
  }, [])

  return (
    <div style={{ backgroundColor: homeBackground }}>
      <TopBar data-testid="top-bar-sticky" />

      <div>
        <img src='/image4.png' alt='About us banner' width={'100%'} />
      </div>

      <div style={styles.homeSection1}>
        <Typography style={styles.homeSection1Title}>Our Story</Typography>
        <p>At the core of our approach is a dedication to transforming financial operations with
          <span style={{ fontStyle: 'italic' }}> {CONST_SITE_LABEL}</span>. We started with a goal to give organizations
          powerful data insights, which led to the creation of our FinOps solutions. With a focus on innovation and
          a strong grasp of cloud technologies, we strive to reduce costs, improve scalability, and boost financial
          performance. Our skilled team specializes in cloud analytics and has developed custom strategies to manage
          the complexities of financial operations in the cloud. Through teamwork, we've seen businesses grow and
          achieve higher levels of efficiency and strategic decision-making. Join us on this journey as we continue
          to lead the way in FinOps in the cloud, reshaping how organizations use analytics for financial success.
        </p>
      </div>

      <div style={styles.homeSection1}>
        <Typography style={styles.homeSection1Title}>Our Values</Typography>
        <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }} style={{
          paddingTop: '2vw',
        }}>
          {ourValues.map((service, index) => (
            <Grid item xs={4} sm={4} md={4} key={index} data-testid="service-item">
              <Card style={{ height: '250px' }}>
                <CardHeader
                  avatar={<Icon style={{
                    fontSize: '40px',
                    // color: homeColor.hover,
                    color: '#f2690d',
                    // alignSelf: 'center'
                    display: 'flex'
                  }}>{service.icon}</Icon>}
                  title={<Typography variant="h6">{service.title}</Typography>}
                />
                <CardContent>
                  <Typography className='first-letter-capital' variant="body2" style={{ color: homeColor.subtext }}>{service.description}</Typography>
                </CardContent>
              </Card>

              {/* <Paper className='about-paper' >
                <Icon style={{
                  fontSize: '50px',
                  color: homeColor.hover
                }}>{service.icon}</Icon>
                <Typography variant="h6">{service.title}</Typography>
                <Typography variant="body2" style={{ color: homeColor.subtext }}>{service.description}</Typography>
              </Paper> */}
            </Grid>
          ))}
        </Grid>
      </div>

      <Footer />
    </div>
  )
}
